var _defs, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb923c;}.cls-2{fill:#fff;}.cls-3{fill:#c2410c;}.cls-4{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:44px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Prancheta 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69,
    y: 69,
    width: 443,
    height: 443,
    rx: 54.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.71,373.38q3.69,7,3.89,12.39a13,13,0,0,1-3.15,9.25q-3.33,3.89-11.1,8-11.85,5.55-18.5,3t-12.21-14.43L290.5,217.61l-82.14,173.9q-5.55,11.48-12.21,14.06t-18.5-3q-7.41-3.69-10.91-7.77a12.5,12.5,0,0,1-3-9.81q.56-5.73,4.25-13.87L269.78,159.52a24.15,24.15,0,0,1,8.7-9.62,22.46,22.46,0,0,1,12.39-3.7,19.62,19.62,0,0,1,8.14,1.66,25.09,25.09,0,0,1,6.85,4.63,26.2,26.2,0,0,1,5.36,7.4ZM224.64,337.86l17.76-38.48H339l17.39,38.48Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 568,
    y: 568,
    width: 443,
    height: 443,
    rx: 54.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M705.7,903.46q-10,0-14.62-3.15a15.57,15.57,0,0,1-6.29-8.32,36,36,0,0,1-1.66-11.1V667.4a40.18,40.18,0,0,1,1.48-11.1A14.49,14.49,0,0,1,690.9,648q4.8-3.13,15.17-3.14l69.56.37q27,0,49.58,9.43a118,118,0,0,1,39.22,26.46,120.2,120.2,0,0,1,25.9,40.51q9.24,23.5,9.25,51.25,0,28.86-9.25,52.91a123,123,0,0,1-25.9,41.44A114.38,114.38,0,0,1,824.84,894q-23,9.43-50.32,9.44Zm22.57-44.77h47.36q23.31,0,41.07-10.55a73.35,73.35,0,0,0,27.75-29.41q10-18.87,10-44t-10-44.22a73.09,73.09,0,0,0-27.75-29.6q-17.76-10.54-41.44-10.54h-47Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 568,
    y: 69,
    width: 443,
    height: 443,
    rx: 54.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M712.54,404.46q-10,0-14.61-3.33a14.69,14.69,0,0,1-5.92-8.88,53.37,53.37,0,0,1-1.3-12.21V169.88a49.34,49.34,0,0,1,1.3-11.66,15.21,15.21,0,0,1,6.1-8.88q4.8-3.51,14.8-3.51h97.68q21.45,0,37.74,10a73.35,73.35,0,0,1,35.15,62.9,74.84,74.84,0,0,1-2,17.39A59.69,59.69,0,0,1,875.16,252a57.63,57.63,0,0,1-10.55,13.32,66,66,0,0,1,14.8,16.46,78.1,78.1,0,0,1,9.44,20.91,82.62,82.62,0,0,1-3.15,54.2,76.8,76.8,0,0,1-71.41,47.55Zm22.94-43.66h75.11a43.09,43.09,0,0,0,18.87-4.07,29.79,29.79,0,0,0,13.32-12.58q4.8-8.5,4.81-22.2,0-10.72-2.77-17.21a23.59,23.59,0,0,0-7.59-10,31.11,31.11,0,0,0-10.36-5,59,59,0,0,0-11.28-1.85c-3.83-.24-7.35-.37-10.55-.37H788.39q-9.63,0-14.06-4.44t-4.44-15.17q0-10.35,4.81-14.62t14.8-4.25h16.28q4.8,0,10.55-.37a30,30,0,0,0,10.91-2.78,19.46,19.46,0,0,0,8.51-7.95q3.33-5.55,3.33-15.91,0-16.65-8.69-24.24T801,190.23H735.48Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69,
    y: 568,
    width: 443,
    height: 443,
    rx: 54.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "163.5 805 256.5 887 417.5 692"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.430f24fa800134b78eabc2196a1be821.svg";
export { ForwardRef as ReactComponent };